// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"160":"e3da27b0","753":"725d9687"}[chunkId] + ".js";
};